export const EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE = "EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE";
export const EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE_SUCCESS = "EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE_SUCCESS";
export const EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE_FAIL = "EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE_FAIL";

export const RESET = "RESET";

